<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import emailjs from "@emailjs/browser";

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="serv1">
  <div class="image-container1">
    <img src="/img/20.jpg" alt="Background Image" />
  </div>
  <div class="overlay"></div>
  <!-- Added overlay -->
  <div class="content1">
    <button class="development-button">Development</button>
    <h1 class="services-heading">
      Software Development at Craft2Code
    </h1>
    <p class="services-description">
      Software development is the strategic process of designing, building, testing, and
      maintaining reliable, scalable applications and systems that support business growth.
    </p>
  </div>
</div>

<div class="container">
  <div class="left">
    <div class="text">
      <h2>Software Development – Driving Business Innovation</h2>

      <p style="color: black;">
        At Craft2Code, software development is more than writing code — it's
        about creating secure, scalable, and high-performance applications that
        solve complex business challenges.<br /><br />
        Our team designs, builds, tests, and maintains custom software solutions
        tailored to your unique requirements. From enterprise platforms and SaaS
        products to specialized tools and integrations, we deliver systems that
        empower your business to grow, innovate, and succeed.<br /><br />
        We combine technical expertise with strategic insight to ensure every
        application is reliable, efficient, and built for long-term scalability.
        Our developers are skilled in modern programming languages, including
        Python, Java, JavaScript, C++, and more, using the right technologies
        for each project to deliver robust, maintainable solutions.
      </p>
    </div>
  </div>
  <div class="right">
    <div class="images">
      <img src="/img/21.png" alt="Image 1" class="right-image" />
      <img src="/img/22.png" alt="Image 2" class="right-image" />
    </div>
  </div>
</div>
<div class="horizontal-container">
  <div class="image-containeH">
    <img src="/img/23.jpg" alt="Background Image" class="full-width" />
  </div>
  <div class="text-container">
    <p class="importance">IMPORTANCE</p>
    <h1 class="services-heading1">The Role of<br /> Developers</h1>
    <p class="services-description1">
      Software developers, often referred to as coders or<br />
      programmers, are the creative minds behind the digital innovations we use daily.
    </p>
    <div class="icons">
      <div>
        <i class="fas fa-info-circle" style="color: white; margin-right: 10px;"
        ></i>
        <!-- Added margin-right here -->
        <span style="color: white;">PPD Development</span>
      </div>
      <div style="margin-top: 10px;">
        <i class="fas fa-laptop-code" style="color: white; margin-right: 10px;"
        ></i>
        <!-- Added margin-right here -->
        <span style="color: white;">Easy to Use</span>
      </div>
    </div>
  </div>
</div>
<div class="horizontal-container1">
  <div class="title">Boost Your Business with Our Development Expertise</div>

  <div class="leftho">
    <div class="icon">
      <i class="fas fa-info-circle"></i>
      <div class="icon-text">
        <span class="icon-title">Requirements Gathering</span>
        <p>
          We start by gathering and analyzing requirements from all
          stakeholders — clients, end-users, and business analysts — to
          ensure that every solution aligns perfectly with your business goals.
        </p>
      </div>
    </div>
    <div class="icon">
      <i class="fas fa-laptop-code"></i>
      <div class="icon-text">
        <span class="icon-title">Data Integration & Scalability</span>
        <p>
          Our applications are designed to scale seamlessly as your user base
          and data grow, ensuring long-term performance and reliability.
        </p>
      </div>
    </div>
  </div>
  <div class="rightho">
    <div class="icon">
      <i class="fas fa-check-circle"></i>
      <div class="icon-text">
        <span class="icon-title">DevOps & Interoperability</span>
        <p>
          We build software to integrate smoothly with other systems and
          platforms, enabling efficient workflows and reducing operational
          friction.
        </p>
      </div>
    </div>
    <div class="icon">
      <i class="fas fa-laptop-code"></i>
      <div class="icon-text">
        <span class="icon-title">Analytics & Performance Monitoring</span>
        <p>
          We embed analytics and performance tracking into every solution,
          helping you make informed decisions and optimize your systems as
          they evolve.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      
    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }


  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }

  /* ------------------------------------ */
  .serv1 {
    text-align: center;
    margin-bottom: 40px;
    width: 100%;
    position: relative;
  }

  .image-container1 {
    width: 100%;
    height: 100vh; /* Full viewport height */
    overflow: hidden;
  }

  .image-container1 img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensures the image covers the container */
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(
      0,
      0,
      0,
      0.5
    ); /* Optional: for a darker overlay effect */
    z-index: 1;
  }

  .content1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    text-align: center;
    color: #ffffff;
    z-index: 2; /* Ensure it is above the overlay */
    padding: 0 20px;
  }

  .content1 .services-heading {
    color: #ffffff;
    font-size: 45px;
    font-family: BreeSerif;
    text-align: center;
    font-weight: bold;
    margin-bottom: 40px;
  }

  .content1 .services-description {
    color: #ffffff;
    font-size: 1.4rem;
    font-family: SourceSans;
    margin-top: 60px;
    text-align: center;
  }

  .services-heading1 {
    color: #ffffff;
    font-size: 40px;
    font-family: BreeSerif;
  }

  .services-description1 {
    color: #ffffff;
    font-size: 1.4rem;
    font-family: SourceSans;
    margin-top: 20px;
  }

  .container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    justify-content: center;
  }

  .left,
  .right {
    width: 45%;
  }

  .left {
    padding-right: 2%; /* Adjust this value to move the text closer to the images */
  }

  .right {
    margin-left: -2%; /* Adjust this value to move the images closer to the text */
  }

  .text h2 {
    padding: 20px;
    font-size: 45px;
    font-family: BreeSerif;
  }

  .images {
    display: flex;

    gap: 20px; /* Adds space between the images */
  }

  .images img {
    width: 100%;
    height: 500px;
  }

  .right-image {
    width: 100%;
    height: 400px;
    max-width: 300px;
    /* Adjust this value to control the image width */
  }

  .full-width {
    width: auto;
    height: 400px;
    object-fit: cover;
  }

  .development-button {
    background-color: #333333;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .development-button:hover {
    background-color: #dc1f26;
  }

  .horizontal-container {
    display: flex;
    align-items: center; /* Vertically center the content */
    justify-content: center; /* Horizontally center the content */
    width: 100%;
    height: 100vh; /* Full height of the viewport */
    box-sizing: border-box; /* Include padding and border in element's total width and height */
    background-color: #2c2c2c; /* Add a background color to the div */
    color: white; /* Set text color to white */
  }

  .image-containeH {
    flex: 1; /* Take up equal space as the text container */
    display: flex;
    align-items: center; /* Center the image vertically */
    justify-content: center; /* Center the image horizontally */
    height: 80%; /* Adjust the height to make the image smaller */
  }

  .image-containeH img {
    max-width: 80%; /* Adjust the width to make the image smaller */
    height: 100%; /* Ensure image fits within the container */
  }

  .text-container {
    flex: 1; /* Take up equal space as the image container */
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align text to start of container */
    justify-content: center; /* Center the text vertically */
    padding: 20px; /* Add some padding for better readability */
    box-sizing: border-box; /* Include padding in the element's total width and height */
  }

  .importance {
    color: white; /* Set the color of the "IMPORTANCE" text to white */
  }

  .services-heading {
    font-family: BreeSerif;
    text-align: left; /* Align heading text to the left */
  }

  .services-description {
    font-size: 1.4rem;
    font-family: SourceSans;
    text-align: left; /* Align description text to the left */
    margin-top: 20px;
  }

  .icons {
    margin-top: 20px; /* Add some space between text and icons */
  }
  .icons i {
    font-size: 1.8rem;
  }

  .icons div {
    display: flex;
    align-items: center; /* Center the icon and text vertically */
    margin-bottom: 10px; /* Add some space between icons */
  }

  .horizontal-container1 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 60px;
    margin-bottom: 60px;
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 45px;
    color: #333333;
    margin-bottom: 10px;
    font-family: BreeSerif;
  }

  .leftho,
  .rightho {
    width: 50%; /* Adjusted width for better spacing */
  }

  .icon {
    display: flex;
    align-items: flex-start;
    margin-bottom: 40px; /* Consistent spacing between icon sections */
  }

  .icon i {
    margin-right: 10px;
    font-size: 1.8rem;
  }

  .icon-title {
    color: #333333;
    margin-left: 10px;
    font-size: 30px;
    font-family: BreeSerif;
  }

  .icon-text {
    flex: 1;
  }

  .icon-text p {
    color: #333333;
    margin-top: 10px;
  }
  @media (min-width: 1040px) and (max-width: 1324px) {
    .text h2 {
      font-size: 40px;
    }
    .images img {
      height: 450px;
    }
    .right-image {
      height: 350px;
    }
    .services-heading1 {
      font-size: 35px;
    }
    .services-description1 {
      font-size: 1.2rem;
    }
    .icons i {
      font-size: 1.5rem;
    }
    .rightfo button {
      padding: 10px 16px; /* Adjust button padding */
      font-size: 16px; /* Adjust button font size */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
  }
  @media (min-width: 769px) and (max-width: 1040px) {
    .container {
      flex-direction: column;
      align-items: center;
      height: auto;
    }
    .left,
    .right {
      width: 90%;
    }
    .text {
      text-align: center; /* Center-align the text container */
    }
    .text h2 {
      font-size: 35px;
      text-align: center; /* Center-align the heading */
    }
    .text p {
      text-align: center; /* Center-align the paragraph text */
    }
    .images {
      flex-direction: row;
      justify-content: center;
    }
    .images img {
      height: 400px;
    }
    .right-image {
      height: 300px;
    }
    .horizontal-container {
      flex-direction: column;
      align-items: center;
      height: auto;
      margin-top: 5%;
    }
    .image-containeH {
      height: auto;
      margin-bottom: 20px;
    }
    .image-containeH img {
      max-width: 100%;
      height: auto;
    }
    .text-container {
      width: 90%;
      padding: 10px;
    }
    .services-heading1 {
      font-size: 30px;
    }
    .services-description1 {
      font-size: 1.2rem;
    }
    .icons i {
      font-size: 1.4rem;
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }
  /* For screens with a maximum width of 750px */ /* For screens with a maximum width of 750px */
  @media (min-width: 481px) and (max-width: 768px) {
    .content1 {
      width: 80%;
    }
    .container {
      flex-direction: column;
      align-items: center;
      height: auto;
    }
    .left,
    .right {
      width: 100%;
    }
    .text {
      text-align: center; /* Center-align the text container */
    }
    .text h2 {
      text-align: center; /* Center-align the heading */
    }
    .text p {
      font-size: 14px;
      padding: 0 5px;
      text-align: center; /* Center-align the paragraph text */
    }
    .images {
      flex-direction: row;
      justify-content: center;
      align-items: center; /* Center-align the images within the container */
      text-align: center;
      gap: 10px;
    }
    .images img {
      height: 300px;
      width: 100%; /* Ensure the image maintains its aspect ratio */
    }
    .right-image {
      height: 250px;
      width: auto; /* Ensure the image maintains its aspect ratio */
    }
    .horizontal-container {
      flex-direction: column;
      align-items: center;
      height: auto;
      margin-top: 5%;
    }
    .image-containeH {
      height: auto;
      margin-bottom: 15px;
    }
    .image-containeH img {
      max-width: 100%;
      height: auto;
    }
    .text-container {
      width: 95%;
      padding: 10px;
    }
    .services-heading1 {
      font-size: 24px;
    }
    .services-description1 {
      font-size: 1rem;
    }
    .icons i {
      font-size: 1.2rem;
    }
    .horizontal-container1 {
      flex-direction: column;
      align-items: left;
    }

    .title {
      font-size: 36px; /* Slightly smaller font size for title */
      margin-bottom: 20px; /* Adjusted margin for better spacing */
      padding: 0 0px; /* Added padding for better readability */
    }

    .leftho,
    .rightho {
      width: 95%; /* Full width for tablet view */
      padding: 0 0px; /* Added padding for better spacing */
    }

    .icon {
      flex-direction: row;
      align-items: flex-start;
      margin-bottom: 30px; /* Adjusted spacing between icon sections */
    }

    .icon i {
      font-size: 1.6rem; /* Slightly smaller icon size */
      margin-right: 10px; /* Added margin for better spacing */
    }

    .icon-title {
      font-size: 26px; /* Slightly smaller font size for icon titles */
      margin-left: 0px; /* Keep margin for alignment */
    }

    .icon-text p {
      left: 0;
      font-size: 14px; /* Slightly smaller font size for paragraphs */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      font-size: 28px; /* Adjust font size for smaller screens */
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }

  /* For screens with a maximum width of 550px */
  @media (max-width: 480px) {
    .serv1 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      text-align: left;
      width: 100%;
    }
    .image-container1 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .horizontal-container1 {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      align-items: center;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

    .title {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 28px; /* Smaller font size for title */
      margin-bottom: 20px; /* Adjusted margin for better spacing */
      padding: 0 0px; /* Added padding for better readability */
    }

    .leftho,
    .rightho {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 92%; /* Full width for mobile view */
      padding: 0 0px; /* Added padding for better spacing */
    }

    .icon {
      flex-direction: column;
      align-items: flex-start;

      margin-bottom: 30px; /* Adjusted spacing between icon sections */
    }

    .icon i {
      font-size: 1.5rem; /* Smaller icon size */
      margin-bottom: 10px; /* Added margin for better spacing */
    }

    .icon-title {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 24px; /* Smaller font size for icon titles */
      margin-left: 0; /* Remove margin for better alignment */
      margin-bottom: 10px; /* Added margin for better spacing */
    }

    .icon-text p {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      left: 0;
      font-size: 14px; /* Smaller font size for paragraphs */
    }
    .content1 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }
    .container {
      flex-direction: column;
      width: 100%;

      height: auto;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .text {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .left {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }
    .right {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .text h2 {
      font-size: 18px;
      padding: 0px;
    }
    .text p {
      font-size: 12px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      padding: 0 0px;
    }
    .images {
      flex-direction: row;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      gap: 5px;
    }
    .images img {
      height: 250px;
    }
    .right-image {
      height: 200px;
    }
    .horizontal-container {
      flex-direction: column;
      /* align-items: center; */
      width: 100%;
      height: auto;
      margin-top: 5%;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .image-containeH {
      height: auto;
      margin-bottom: 15px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .image-containeH img {
      max-width: 100%;
      height: auto;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .text-container {
      width: 95%;
      padding: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .services-heading1 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      font-size: 24px;
    }
    .services-description1 {
      font-size: 1rem;
    }
    .icons i {
      font-size: 1.2rem;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 0px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }

  /* For screens with a maximum width of 350px */
</style>
